<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Recovery</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>

          <div class="card-header">
            <div style="width: 100%; margin: 0;">
              <selectlist
                name="handler_id"
                label="Handler"
                label-name="full_name"
                :options="handlers"
                :value="filters.handler_id"
                @input="setHandler"
                :stacked="true"
              ></selectlist>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>Handler</th>
                  <th>Claim Reference</th>
                  <th>Claim Type</th>
                  <th>Client Name</th>
                  <!--                  <th>Hire Start Date</th>-->
                  <!--                  <th>Total Hire Days</th>-->
                  <th>Third Party Insurer</th>
                  <th v-if="hasAgent">Managed By Agent</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody v-if="incidents.length">
                <tr v-bind:key="index" v-for="(incident, index) in incidents">
                  <td>
                    {{ incident.handler?.full_name || 'Not Assigned' }}
                  </td>
                  <td>
                    {{ incident.source?.claim_reference || 'Not Provided' }}
                  </td>
                  <td>
                    {{
                      incident.source?.incident_claim_type?.label ||
                        'Not Provided'
                    }}
                  </td>
                  <td>
                    {{ incident.client?.full_name || 'Not Provided' }}
                  </td>

                  <!--                  <td>-->
                  <!--                    {{ getHireStartDate(incident) }}-->
                  <!--                  </td>-->
                  <!--                  <td>-->
                  <!--                    {{ getTotalHireDays(incident) }}-->
                  <!--                  </td>-->

                  <td>
                    {{ getThirdPartyInsurer(incident) }}
                  </td>
                  <td v-if="hasAgent">
                    <span
                      class="label label-primary"
                      v-if="incident.manager_name === 'Agent'"
                      >Yes</span
                    >
                    <span class="label label-warning" v-else>No</span>
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-primary"
                      v-on:click.prevent="assignIncidentToHandler(incident)"
                      v-if="hasPermission('claims.reassign')"
                    >
                      {{
                        incident.handler ? 'Re-Assign Handler' : 'Not Assigned'
                      }}
                    </button>
                    <router-link
                      class="btn btn-primary"
                      :to="`/recovery/${incident.identifier}`"
                    >
                      View
                    </router-link>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="!incidents.length">
                <tr>
                  <td colspan="9" class="text-center">
                    There are currently no claims in Recovery
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="paginator_data"
              v-on:updateResults="getData"
              filter="stage"
              filterParams="recovery"
              params="&parts=thirdParties"
            ></pagination>
          </div>
        </div>
      </div>
    </div>

    <assign-handler
      :incident="incident"
      v-if="incident"
      :handlers="handlers"
      :show="modals.assign"
      v-on:close="closeAssignToHandlerModal"
      v-on:assigned="handlerWasAssigned"
    ></assign-handler>
  </div>
</template>

<script>
import AssignHandler from './../Shared/AssignHandler.vue';
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    AssignHandler,
    PageHeader
  },

  data() {
    return {
      paginator_data: {},
      incident: null,
      filters: {
        handler_id: null
      },
      modals: {
        assign: false
      },
      loading: false,
      incidents: []
    };
  },

  computed: {
    handlers() {
      return this.$store.getters['ClaimHandlers/all'];
    },

    hasAgent() {
      return false;
      //                return !!this.$store.getters.agent;
    },

    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    }
  },

  mounted() {
    this.$store.commit('ClaimHandlers/retrieve');

    this.findIncidents();
  },

  methods: {
    getData(url) {
      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key]}`;
      });

      this.loading = true;

      window.Ajax.get(url)
        .then(response => {
          this.incidents = response.data.data;
          this.paginator_data = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },

    setHandler(handlerId) {
      this.filters.handler_id = handlerId;

      this.getData(
        `/incidents?filter[stage]=recovery&per_page=${this.perPage}`
      );
    },

    handlerWasAssigned() {
      this.modals.assign = false;
      this.incident = null;
      this.findIncidents();

      window.toastify.success('Assigned', 'The case was assigned.');
    },

    closeAssignToHandlerModal() {
      this.modals.assign = false;
    },

    assignIncidentToHandler(incident) {
      this.incident = incident.identifier;
      this.modals.assign = true;
    },

    // getHireStartDate(incident) {
    //   if (!incident.credit_hire) {
    //     return 'Not Available';
    //   }
    //
    //   if (!incident.credit_hire.vehicle) {
    //     return 'Not Available';
    //   }
    //
    //   if (!incident.credit_hire.vehicle.start_date) {
    //     return 'Not Available';
    //   }
    //
    //   return window.DateManager.format(incident.credit_hire.vehicle.start_date);
    // },
    //
    // getTotalHireDays(incident) {
    //   if (!incident.credit_hire) {
    //     return 'Not Available';
    //   }
    //
    //   if (!incident.credit_hire.vehicle) {
    //     return 'Not Available';
    //   }
    //
    //   if (!incident.credit_hire.vehicle.start_date) {
    //     return 'Not Available';
    //   }
    //
    //   if (incident.credit_hire.vehicle.end_date) {
    //     return window.DateManager.differenceInDays(
    //       incident.credit_hire.vehicle.end_date,
    //       incident.credit_hire.vehicle.start_date
    //     );
    //   }
    //
    //   return window.DateManager.differenceInDays(
    //     new Date(),
    //     incident.credit_hire.vehicle.start_date
    //   );
    // },

    getThirdPartyInsurer(incident) {
      if (!incident.third_parties.length) {
        return 'Not Available';
      }

      if (!incident.third_parties[0].insurer) {
        return 'Not Available';
      }

      return incident.third_parties[0].insurer.name;
    },

    findIncidents() {
      this.getData(
        `/incidents?parts=thirdParties&filter[stage]=recovery&per_page=${this.perPage}`
      );
    }
  }
};
</script>
